const projectsData = [
    {
        id: 1,
        title : "Project 2",
        desc:"Randome Desc",
        category:"react",
        tags: "#react #node",
        github:"",
        youtube:"link",
        live:"link",
    },
    {
        id: 1,
        title : "Project 1",
        desc:"Randome Desc",
        category:"react",
        tags: "reactnode",
        github:"link",
        youtube:"link",
        live:"link",
    },
    {
        id: 1,
        title : "Project 1",
        desc:"Randome Desc",
        category:"node-js",
        tags: "#react #node",
        github:"link",
        youtube:"link",
        live:"link",
    },
    {
        id: 1,
        title : "Project 1",
        desc:"Randome Desc",
        category:"node-js",
        tags: "#react #node",
        github:"link",
        youtube:"link",
        live:"link",
    },
    {
        id: 1,
        title : "Project 1",
        desc:"Randome Desc",
        category:"node-js",
        tags: "#react #node",
        github:"link",
        youtube:"link",
        live:"link",
    },
    {
        id: 1,
        title : "Project 1",
        desc:"Randome Desc",
        category:"",
        tags: "#react #node",
        github:"link",
        youtube:"link",
        live:"link",
    },
    {
        id: 1,
        title : "Project 1",
        desc:"Randome Desc",
        category:"mern",
        tags: "#react #node",
        github:"link",
        youtube:"link",
        live:"link",
    }
]

export default projectsData